import script from "./ColumnModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnModal.vue?vue&type=script&lang=ts&setup=true"

import "./ColumnModal.vue?vue&type=style&index=0&id=e7728df4&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7728df4"]])

export default __exports__